import { render, staticRenderFns } from "./EquipControls.vue?vue&type=template&id=608d2642"
import script from "./EquipControls.vue?vue&type=script&lang=js"
export * from "./EquipControls.vue?vue&type=script&lang=js"
import style0 from "./EquipControls.vue?vue&type=style&index=0&id=608d2642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports